const helpers = {
  groupSavedFilters(savedFilters) {
    return savedFilters.reduce((acc, item) => {
      const { type } = item;

      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(item);

      return acc;
    }, {});
  },
};

export default helpers;
